// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"080a5c89","312":"67377e91","484":"5266f985","525":"52fa58a6","551":"b8b82f28","770":"8d7b9bf4","815":"d4aeeff6","950":"bafc10c7"}[chunkId] + ".chunk.js";
};